import assetApi from '@Apis/assets.api';
import { AssetFilter, AssetFilterListItem } from '@Types/asset.types';

export const getAssetFilterListApi = () => {
	const $projection = '_id,name,assetType';
	const query = new URLSearchParams({ $projection });
	const address = `/assets-filter/?${query.toString()}`;
	return assetApi.get<AssetFilterListItem[]>(address);
};

export const getAssetFilterApi = (id: string) => {
	const address = `/assets-filter/${id}`;
	return assetApi.get<AssetFilter>(address);
};
